module.exports = __webpack_public_path__ + "img/gaia48-sina.7d320dbc.jpg";